// This file was generated by lezer-generator. You probably shouldn't edit it.
import { LRParser } from '@lezer/lr';
export const durationParser = LRParser.deserialize({
  version: 14,
  states:
    "$UOhQPOOOOQO'#Cc'#CcO!QQPO'#CkO![QPO'#ChO!uQPO'#CpOOQO'#Cp'#CpOVQPO'#CpQOQPOOOOQO,58z,58zOYQPO,58zO!|QPO,59TOOQO,59S,59SO#RQPO,59SOoQPO'#C`OOQO'#Cl'#ClO#WQPO,58yO#_QPO,59[OOQO,59[,59[OOQO1G.f1G.fO#fQPO1G.oOOQO1G.n1G.nOOQO-E6j-E6jO#nQPO7+$ZOOQO<<Gu<<Gu",
  stateData:
    '#s~OcOS~OTQOWPOXPOYPOZPO~OQUO~PVOUXOWPOXPOYPOZPO~O^YOa_X~PoOTZOU[O~OT]OWPOXPOYPOZPO~OadX~P!dOTcO~OTdO~OaRa~P!dOada~P!dO^fOa]i~OTgO~O',
  goto: '!aePPPflPPwPPPPlfPf!VPPP!^QTORaUQSOU^S_`R`UYROSU_`SWQ]RbXS_S`Re_RVO',
  nodeNames:
    '⚠ Duration Sign CompoundDuration NumberAndUnit Number Dot Unit Days Hours Minutes Seconds UnitAndNumber TimeFormat Colon PlainNumber',
  maxTerm: 20,
  skippedNodes: [0],
  repeatNodeCount: 1,
  tokenData:
    "'i~RcX^!^pq!^{|#R}!O#R!O!P#W!Q![#]![!]#v!f!g#{!j!k$k!o!p%a!u!v&e#y#z!^$f$g!^#BY#BZ!^$IS$I_!^$I|$JO!^$JT$JU!^$KV$KW!^&FU&FV!^~!cYc~X^!^pq!^#y#z!^$f$g!^#BY#BZ!^$IS$I_!^$I|$JO!^$JT$JU!^$KV$KW!^&FU&FV!^~#WOQ~~#]OU~~#bQT~!O!P#h!Q![#]~#kP!Q![#n~#sPT~!Q![#n~#{O^~~$QQW~!c!d$W!{!|$f~$ZP!{!|$^~$cPW~!u!v$f~$kOW~~$pQX~!q!r$v!t!u%S~$yP!w!x$|~%PP!t!u%S~%XPX~!u!v%[~%aOX~~%fPY~!k!l%i~%lP!p!q%o~%tQY~!u!v%z!w!x&P~&POY~~&SP!v!w&V~&YP!g!h&]~&bPY~!u!v%z~&jPZ~!g!h&m~&pP!e!f&s~&xQZ~!q!r'O!u!v'd~'RP!p!q'U~'XP!f!g'[~'aPZ~!u!v'd~'iOZ~",
  tokenizers: [0],
  topRules: { Duration: [0, 1] },
  tokenPrec: 0,
  termNames: {
    '0': '⚠',
    '1': '@top',
    '2': 'Sign',
    '3': 'CompoundDuration',
    '4': 'NumberAndUnit',
    '5': 'Number',
    '6': 'Dot',
    '7': 'Unit',
    '8': 'Days',
    '9': 'Hours',
    '10': 'Minutes',
    '11': 'Seconds',
    '12': 'UnitAndNumber',
    '13': 'TimeFormat',
    '14': 'Colon',
    '15': 'PlainNumber',
    '16': '(NumberAndUnit | UnitAndNumber)+',
    '17': '␄',
    '18': '%mainskip',
    '19': 'space',
    '20': 'expression',
  },
});
